<template>
  <div class="container-cap">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small>
            <span v-if="!isNational">
              {{ region }}
            </span>
            <span v-else>
              Programme National
            </span>
            {{ year }}
          </small>
          <br>
          Caractéristiques
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="form-inline">
              <div v-if="datasetList.length === 0">
                <strong>
                  <loading-text>Récupération des jeux de données</loading-text>
                </strong>
              </div>
              <div v-else class="form-group">
                <dropdown ref="dropdown">
                  <btn type="default" class="dropdown-toggle">
                    <span v-if="dataset == null">
                      Jeu de donnée
                    </span>
                    <span v-else-if="dataset === ''">
                      Toutes les fiches validées
                    </span>
                    <span v-else>
                        {{ dataset }}
                    </span>

                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li>
                      <a role="button" @click="dataset = ''">
                        (Aucun : toutes les fiches validées)
                      </a>
                    </li>
                    <li v-for="d in datasetList"
                        :key="`dataset-${d}`">
                      <a role="button" @click="dataset = d">
                        {{ d }}
                      </a>
                    </li>
                  </template>
                </dropdown>
              </div>
              <div v-if="dataset != null && establishmentList.length > 0"
                   class="form-group">
                <dropdown ref="dropdown" tag="span">
                  <btn class="dropdown-toggle" type="warning">
                    {{ module == null ? '(Module)' : moduleName }}
                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="m in availableModules"
                        :key="m.key">
                      <a role="button" @click="module = m.key">
                        <span :class="`label label-${m.key}`">{{ m.label }}</span>
                      </a>
                    </li>
                  </template>
                </dropdown>
              </div>
              <div v-else-if="dataset != null" class="form-group">
                <strong>
                  <loading-text>Chargement des inscriptions</loading-text>
                </strong>
              </div>
              <span v-if="module != null">
                <span v-show="!display">
                  <strong>
                    <loading-text>Téléchargement des fiches</loading-text>
                  </strong>
                </span>
                <span v-show="display">
                  <div class="form-group">
                    <div class="input-group">
                      <input required ref="input"
                             id="input" tabindex="0"
                             class="form-control" v-model="text"
                             type="text"
                             placeholder="Chercher un établissement..."
                             autocomplete="off"/>
                    </div>
                    <typeahead v-model="selection"
                               open-on-focus
                               force-select
                               target="#input"
                               :data="establishmentList"
                               item-key="value"/>
                  </div>
                  <div class="form-group">
                    <btn @click="selection = null; text = ''"
                         :disabled="selection == null">
                      Effacer
                    </btn>
                  </div>
                </span>
              </span>
            </div>
          </div>
          </div>
      </div>
    </div>
    <div class="row" v-if="display && this.all.list">
      <sui-filter-bar :multiFilterData="filterInputList"
           :multiFilterEvents="filterEvents"
           :selectionInfo="filterSelectionInfo">
      </sui-filter-bar>
      <save-blob :target="csv"></save-blob>
      <div class="col-xs-12" v-if="current != null">
        <h3>{{current.surv.establishment.name}}</h3>
        <div v-if="current.data != null">
          <sui-results-caracteristics
            :caracteristics="flatDistribution"
            :title="currentTitle"
            :subtitle="subtitle">
            <p>Aucune fiche pour cet établissement.</p>
          </sui-results-caracteristics>
        </div>
        <div v-else-if="currentFilter !== ''">
          <alert type="warning">
            <p>
              Aucune fiche ne correspond au filtre choisi.
            </p>
          </alert>
        </div>
        <div v-else-if="!selectionReady">
          <strong><loading-text>Chargement</loading-text></strong>
        </div>
        <div v-else>
          <alert type="warning">
            <strong>
              Aucune fiche n'a été remplie par cet établissement.
            </strong>
          </alert>
        </div>
      </div>
      <div v-else class="col-xs-12">
        <h2>
          Caractéristiques nationales des fiches
          <span class="label" :class="`label-${module}`">
            {{moduleName}}
          </span>
          <br>
          <small v-if="dataset === ''">
            Toutes les fiches validées
          </small>
          <small v-else>
            {{dataset}}
          </small>
        </h2>
        <sui-results-caracteristics
          :caracteristics="flatDistribution"
          :title="nationalTitle"
          :subtitle="subtitle">
          <p>Aucune fiche n'a été validée.</p>
        </sui-results-caracteristics>
      </div>
    </div>
  </div>
</template>
<script>
import sc from '@/sui/sc/sheetCaracteristics'
import helps from '@/sui/sc/helps/caracteristics'

import regions from '@/sui/tools/regions'
import dataset from '@/sui/tools/dataset'

import loading from '@/sui/components/loadingtext'
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'
import suiFilterBar from '@/sui/components/filter/filterbar'
import saveBlob from '@/sui/components/saveblob'

import modules from '@/sui/data/modules'
import csv from '@/sui/data/sheets/csv'
import caracteristics from '@/sui/data/caracteristics'
import distribution from '@/sui/data/distribution'

import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'sheets-data-observa4',

  data: function () {
    return {
      dataset: null,
      module: null,
      dsSheets: {},
      selection: null,
      selectionReady: false,
      text: '',
      pdfOptions: {
        legend: false,
        showUfs: true
      },
      currentFilter: '',
      currentSheets: [],
      totalSheetCount: 0,
      csv: null,
      sc: sc
    }
  },

  mounted: function () {
    this.fill()
  },

  watch: {
    dataset: function (d) {
      this.selectionReady = false
      this.selection = null
      this.module = null
      this.currentSheets = []
    },

    selection: function (v) {
      if (v != null) {
        this.selectionReady = true
      }
    },

    module: function (m) {
      this.currentSheets = []
      if (m != null && this.full[m].available !== this.year) {
        this.getSheets()
      }
    },

    year: function (y) {
      this.selectionReady = false
      this.selection = null
      this.module = null
      this.dataset = null
      this.currentSheets = []
      this.fill()
    }
  },

  methods: {
    fill: function () {
      if (this.datasetList.length === 0) {
        this.$store.dispatch('dataset/allSpiadiNames', false)
      }

      if (this.surveillances.length === 0) {
        this.$store.dispatch('surveillances/all', this.year)
      }
    },

    onListFiltered: function (e) {
      const { filter, lists, data } = e
      if (lists.length !== 1) {
        return
      }

      this.currentFilter = filter
      this.currentSheets = lists[0]
      this.totalSheetCount = data[0].length
    },

    exportCSV: function (e) {
      const { filter, lists } = e
      if (lists.length !== 1) {
        return
      }

      const list = lists[0]
      if (list.length === 0) {
        return
      }

      const date = moment().format('DD-MM-YYYY-HH-mm-ss')
      const suffix = filter === '' ? '' : ` - ${filter}`
      const filename = `${this.dataset} - ${this.module} - ${date}${suffix}.csv`
      this.active = true
      const vm = this
      csv(
        filename,
        this,
        this.surveillances,
        this.module,
        this.year,
        list,
        (r) => {
          vm.csv = r
          vm.active = false
        },
        vm.setError
      )
    },

    fillSurveillance: function () {
      if (this.surveillances.length === 0) {
        this.$store.dispatch('surveillances/all', this.year)
      }
    },

    getSheets: function () {
      if (this.dataset === '') {
        this.getFull()
        return
      }

      this.getDatasetSheets()
    },

    setError: function (err) {
      this.active = false
      this.$notify({
        type: 'danger',
        title: 'Erreur !',
        content: `Impossible de récupérer les fiches: ${err}.`
      })
    },

    getDatasetSheets: function () {
      const vm = this
      const m = vm.module
      const k = `${vm.dataset}.${m}`
      this.$set(vm.dsSheets, k, {
        available: false,
        list: []
      })

      this.$store.dispatch(
        'dataset/sheets',
        {
          name: this.dataset,
          mod: m,
          cache: true,
          step: m === 'observa4' ? 1 : 2
        }
      ).then(
        (response) => {
          let { err, v } = response.data
          if (err != null) {
            vm.setError(err)
            return response
          }

          if (v.length === 0) {
            vm.dsSheets[k].available = true
            vm.setError('aucune fiche dans la modalité')
            return response
          }
          vm.dsSheets[k].list = Object.freeze(v)
          vm.dsSheets[k].available = true
          return response
        }
      )
    },

    getFull: function (d, r) {
      const vm = this
      const m = vm.module
      const reducer = (result, s) => {
        if (s.modules[m] != null) {
          result.push(s.id)
        }
        return result
      }

      const list = this.surveillances.reduce(reducer, [])
      if (list.length === 0) {
        return
      }

      const request = {
        t: m,
        sv: list,
        st: 'valid',
        y: parseInt(this.year)
      }
      vm.$store.dispatch('bosheet/full', request).then(
        (response) => {
          if (response.data.err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant la récupération des
fiches : ${response.data.err}.`
            })
          }
        }
      ).catch(
        e => {
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant la récupération des
fiches : ${e}.`
          })
        }
      )
    }
  },

  computed: {
    ...mapState({
      datasets: state => state.dataset.names.values,
      full: state => state.bosheet.full,
      allSurv: state => state.surveillances.all
    }),

    ...mapGetters({
      getListByName: 'surveillances/listByName'
    }),

    filterHelps: function () {
      if (this.module == null) {
        return []
      }

      return helps[this.module]
    },

    datasetList: function () {
      return this.datasets[this.year]
    },

    filterEvents: function () {
      const result = {
        filter: this.onListFiltered
      }

      if (this.isNational) {
        result.csv = this.exportCSV
      }

      return result
    },

    filterSelectionInfo: function () {
      if (this.currentSheets == null) {
        return null
      }

      return {
        statistics: {
          count: this.currentSheets.length,
          total: this.totalSheetCount
        },
        filter: this.currentFilter
      }
    },

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    availableModules: function () {
      const result = []
      const list = modules[this.year]
      sc.availableModules.forEach(
        m => {
          const mod = list[m]
          if (mod == null) {
            return
          }

          result.push(
            {
              key: m,
              label: mod.label
            }
          )
        }
      )

      if (this.dataset == null || this.dataset === '' ||
          (parseInt(this.year) >= 2021 && this.dataset.match(/-/) == null)) {
        return result
      }

      return dataset.filterModulesFromDataset(result, this.dataset, 'key')
    },

    nationalTitle: function () {
      const m = this.moduleName
      return `SPIADI${this.year} - Caractéristiques des fiches ${m}`
    },

    currentTitle: function () {
      if (this.current == null) {
        return null
      }
      const e = this.current.surv.establishment.name
      const m = this.moduleName
      return `SPIADI${this.year} - ${e} - Caractéristiques des fiches ${m}`
    },

    subtitle: function () {
      if (this.currentFilter === '') {
        return ''
      }

      return `Filtre actif: ${this.currentFilter}`
    },

    moduleName: function () {
      if (this.module == null) {
        return null
      }

      return modules[this.year][this.module].label
    },

    all: function () {
      if (this.module == null) {
        return null
      }

      if (this.dataset === '') {
        return this.full[this.module]
      }

      const key = `${this.dataset}.${this.module}`
      return this.dsSheets[key]
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    surveillances: function () {
      return this.allSurv[this.year]
    },

    display: function () {
      return this.establishmentList != null &&
             this.establishmentList.length > 0 &&
             this.all != null &&
             this.all.available
    },

    year: function () {
      return this.$route.params.year
    },

    referenceSheets: function () {
      if (this.all == null || !this.all.available) {
        return null
      }

      if (this.selection == null) {
        return this.all.list
      }

      const result = this.all.list.filter(
        i => i.sv === this.selection.surveillance.id
      )
      return result
    },

    current: function () {
      if (this.selection == null) {
        return null
      }

      const result = {
        surv: this.selection.surveillance,
        data: this.flatDistribution
      }
      return result
    },

    establishmentByRegions: function () {
      if (this.establishmentList == null) {
        return null
      }

      const result = {}

      this.establishmentList.forEach(
        e => {
          const f = e.surveillance.establishment.finess
          const ri = regions.indexOf(f)
          result[e.surveillance.id] = ri
        }
      )
      return result
    },

    filterInputList: function () {
      if (!this.display || this.all.list == null) {
        return []
      }

      return [
        {
          list: this.referenceSheets,
          variables: this.filterVariables
        }
      ]
    },

    filterVariables: function () {
      const result = sc.filterVariables[this.module](this.year)
      result.push(
        {
          key: 'finess',
          name: 'Finess',
          field: (s) => {
            const e = this.establishmentList.find(
              e => e.surveillance.id === s.sv
            )
            return e == null ? [] : [e.surveillance.establishment.finess]
          },
          exclusive: ['region', 'finess']
        },
        {
          key: 'region',
          name: 'Région',
          field: (s) => {
            const ri = this.establishmentByRegions[s.sv]
            const r = regions.filters[ri]
            return [r.name]
          },
          exclusive: ['region', 'finess']
        }
      )
      return result
    },

    flatDistribution: function () {
      if (this.currentSheets == null || this.module == null) {
        return null
      }

      try {
        const dist = distribution(this.module, this.currentSheets, this.year)
        dist.etbregion = {
          type: 'rep',
          values: {},
          total: 0
        }
        this.currentSheets.forEach(
          s => {
            const r = this.establishmentByRegions[s.sv]
            const rv = dist.etbregion.values
            if (rv[r] != null) {
              rv[r] += 1
            } else {
              rv[r] = 1
            }
            dist.etbregion.total++
          }
        )
        return caracteristics.flatten[this.module](
          dist, true, dist.year, true
        )
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
        })
      }
      return null
    }
  },

  components: {
    'loading-text': loading,
    'save-blob': saveBlob,
    'sui-results-caracteristics': suiResultsCaracteristics,
    'sui-filter-bar': suiFilterBar
  }
}
</script>
<style scoped lang="less">
.sticky-footer {
  margin-top: -1.0rem;
  margin-bottom: 0.5rem;
  .btn {
    margin-right: 1rem;
  }
}
</style>
